import React, { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
// Component
import AppPageHeader from '../../../components/AppPageHeader'
import { EmptyText, WordBreak } from '../../../components/Common/CellText'
import FileItem from '../../../components/Common/FileItemComponent/FileItem'
import { StatusTag } from '../../../components/Common/StatusTag'
import PDFViewer from '../../../components/PDFViewer/PDFViewer'
import PopoverWatchTime from '../../../components/PopoverWatchTime'
import InternalDocumentComment from '../InternalDocumentComment'
import PopupHandleDocument from './PopupHandleDocumentIncoming'
import PopupHandleHistory from './PopupHandleDocumentIncoming/PopupHandleHistoryIncoming'
//Layout
import DashboardLayout from '../../../layouts/DashboardLayout'
// Styled Component
import {
  BlockLeft,
  BlockRight,
  DocumentContentWrapper,
} from '../../../layouts/InternalDocumentDetailLayout/InternalDocumentDetailLayoutStyled'
// Ant design
import {
  DeleteOutlined,
  HistoryOutlined,
  ProfileOutlined,
  QuestionCircleOutlined,
  SolutionOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  Dropdown,
  Form,
  Menu,
  message,
  Modal,
  Row,
  Tabs,
} from 'antd'
// PDF Viewer
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import { useMediaQuery } from 'react-responsive'
import { blue } from '../../../color'
import AccessControlAction from '../../../components/AccessControlAction'
import {
  MenuDotsBoldIcon,
  PenOutlineIcon,
  SettingsOutlineIcon,
} from '../../../components/AppIcon'
import { KeyValueItem } from '../../../components/Common/KeyValueItem'
import LinkedTask from '../../../components/Common/Linked/LinkedTask'
import LinkedWork from '../../../components/Common/Linked/LinkedWork'
import SpinnerInlineComponent from '../../../components/SpinnerInlineComponent'
import { systemName } from '../../../config'
import {
  ACL_ACTION_TYPE,
  DATE_FORMAT_SLASH,
  DOCUMENT_TYPE,
  TYPE_STATUS,
  VIEWLOG_DATE,
} from '../../../constants'
import utils from '../../../utils'
import PopupPhanPhatDocument from '../PopupPhanPhatDocument'

const { confirm } = Modal

const InternalDocumentIncomingIncomingDocDetailPage = props => {
  const [form] = Form.useForm()

  const isTabletOrMobile = useMediaQuery({
    query: '(max-width: 1299px)',
  })

  const {
    match,
    authenticationStore,
    internalDocumentStore,
    loadingAnimationStore,
    history,
    notificationStore,
    selectPeopleStore,
    aclStore,
  } = props

  const { documentId } = match.params
  // Không xóa dòng khai báo aclActionsByUser (dù k dùng)
  const { aclActionsByUser } = aclStore

  const {
    selectedInternalDocumentIncoming,
    internalDocumentCommentList,
    handlerAssignList,
    combinerAssignList,
    followerAssignList,
  } = internalDocumentStore

  const { currentUser } = authenticationStore
  const currentUserName = currentUser?.username

  const {
    authority_issued_id,
    agency_issued,
    date_issued,
    incoming_date,
    incoming_number,
    document_number,
    signer,
    title,
    attachments,
    linkedTask,
    linkedWork,
    end_date,
    start_date,
    document_status,
    created_at,
    user_create,
  } = selectedInternalDocumentIncoming

  const [
    isVisiblePopupHandleDocument,
    setIsVisiblePopupHandleDocument,
  ] = useState(false)
  const [
    isVisiblePopupHistoryDocument,
    setIsVisiblePopupHistoryDocument,
  ] = useState(false)
  const [
    isVisiblePopupPhanPhatDocument,
    setIsVisiblePopupPhanPhatDocument,
  ] = useState(false)
  const [isLoadingComment, setIsLoadingComment] = useState(false)
  const [attachmentForView, setAttachmentForView] = useState()
  const [commentLeaderList, setCommentLeaderList] = useState([])

  const [departWithUsers, setDepartWithUsers] = useState([])
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    ;(async () => {
      try {
        await selectPeopleStore.getDepartmentWithUsers()
        const response = await selectPeopleStore.getDepartmentWithUsersV2()
        setDepartWithUsers(response.data)
        setLoading(false)
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
        loadingAnimationStore.showSpinner(false)
      }
    })()
  }, [])

  useEffect(() => {
    if (handlerAssignList.length === 0) return
    const commentList = toJS(internalDocumentCommentList).filter(
      cmt => !cmt.deleted && cmt.user_name === handlerAssignList[0].id
    )
    setCommentLeaderList(commentList)
  }, [internalDocumentCommentList, handlerAssignList])

  const renderAuthorityIssuedList = (authorityIssuedId, agencyIssued) => {
    const authorityList = []
    if (authorityIssuedId) {
      authorityList.push(authorityIssuedId.name)
    }
    if (agencyIssued && agencyIssued !== authorityIssuedId?.name) {
      authorityList.push(agencyIssued)
    }
    if (authorityIssuedId || agencyIssued) {
      return authorityList.join(', ')
    }
    return <EmptyText>Không có CQ ban hành.</EmptyText>
  }

  useEffect(() => {
    if (!attachments) return
    setAttachmentForView(
      attachments.find(file =>
        ['pdf', 'doc', 'docx'].includes(utils.getExtensionFile(file.name))
      )
    )
  }, [attachments])

  const renderAttachment = useMemo(
    () => (
      <PDFViewer
        fileId={attachmentForView?.id}
        customStyleObj={{ height: isTabletOrMobile ? 500 : 1000 }}
        fileType={utils.getExtensionFile(attachmentForView?.name)}
        fileName={attachmentForView?.name}
      />
    ),
    [attachmentForView]
  )

  const handleDeleteDocument = async () => {
    loadingAnimationStore.showSpinner(true)
    try {
      await internalDocumentStore.deleteIncomingInternalDocumentById(documentId)
      history.push('/internal-document/incoming-document')
      message.success('Xóa văn bản thành công!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const showConfirm = () => {
    confirm({
      title: 'Bạn có muốn xóa văn bản này không?',
      icon: <QuestionCircleOutlined style={{ color: 'red' }} />,
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: 'danger',
      onOk() {
        handleDeleteDocument()
      },
    })
  }

  const menuHandleDocument = (
    <Menu>
      {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.history__INCOMING) && (
        <Menu.Item
          onClick={() => setIsVisiblePopupHistoryDocument(true)}
          icon={<HistoryOutlined style={{ color: blue }} />}>
          <span style={{ color: blue }}>Lịch sử</span>
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.tao_nv_tu_vb__INCOMING
      ) && (
        <Menu.Item
          onClick={() =>
            history.push(
              `/mission/create?document_code=${documentId}&title=${title}&type=INCOMING`
            )
          }
          icon={<ProfileOutlined style={{ color: blue }} />}>
          <span style={{ color: blue }}>Tạo nhiệm vụ từ văn bản</span>
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.tao_cv_tu_vb__INCOMING
      ) && (
        <Menu.Item
          onClick={() => {
            const documentList = attachments.map(el => el.id + '/' + el.name)
            const queryStringParams = queryString.stringify(
              {
                document_list: documentList,
                incoming_number: incoming_number,
                document_title: title,
                document_code: documentId,
                document_type: DOCUMENT_TYPE.INCOMING,
                comments_leader: commentLeaderList.map(cmt => cmt.content),
                leader_name:
                  handlerAssignList.length > 0 &&
                  utils.getNameInCapitalize(handlerAssignList[0].full_name),
              },
              { arrayFormat: 'index' }
            )
            history.push(`/works/create?${queryStringParams}`)
          }}
          icon={<SolutionOutlined style={{ color: blue }} />}>
          <span style={{ color: blue }}>Tạo công việc từ văn bản</span>
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.delete__INCOMING) && (
        <Menu.Item danger onClick={showConfirm} icon={<DeleteOutlined />}>
          Xóa văn bản
        </Menu.Item>
      )}
    </Menu>
  )

  useEffect(() => {
    ;(async () => {
      loadingAnimationStore.showSpinner(true)
      try {
        await internalDocumentStore.getInternalDocumentIncomingById(documentId)
      } catch (err) {
        history.push('/internal-document/incoming-document')
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
    return () => {
      form.resetFields()
      internalDocumentStore.clearSelectedInternalDocumentIncoming()
      internalDocumentStore.clearAssignList()
      notificationStore.clearNotificationType()
      selectPeopleStore.clearSelected()
    }
  }, [documentId])

  return (
    <DashboardLayout>
      <Helmet>
        <title>
          {title
            ? `${title} | ${systemName} Quản lý VB nội bộ`
            : 'Quản lý VB nội bộ'}
        </title>
      </Helmet>

      <AppPageHeader
        title={
          <>
            {title}
            {StatusTag(TYPE_STATUS.INTERNAL_DOCUMENT_INCOMING, document_status)}
          </>
        }
        showBackButton
        addon={
          <>
            {user_create === currentUserName
              ? aclStore.checkAccessControlAction(
                  ACL_ACTION_TYPE.edit__INCOMING
                ) && (
                  <Button
                    icon={<PenOutlineIcon style={{ width: 16, height: 16 }} />}
                    className="custom-ant-button icon-btn"
                    type="default"
                    onClick={() =>
                      history.push(
                        `/internal-document/incoming-document/${documentId}`
                      )
                    }>
                    Chỉnh sửa văn bản
                  </Button>
                )
              : null}

            {aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.xuly__INCOMING
            ) && (
              <Button
                icon={<SettingsOutlineIcon style={{ width: 16, height: 16 }} />}
                className="custom-ant-button icon-btn"
                type="default"
                onClick={() => setIsVisiblePopupHandleDocument(true)}>
                Xử lý văn bản
              </Button>
            )}
            <Dropdown overlay={menuHandleDocument} trigger={['click']}>
              <Button
                style={{ width: 40, height: 40, flexShrink: 0 }}
                icon={
                  <MenuDotsBoldIcon
                    style={{
                      width: 20,
                      height: 20,
                      transform: 'rotate(90deg)',
                    }}
                  />
                }
                className="custom-ant-button icon-btn"
                type="default"
              />
            </Dropdown>
          </>
        }
      />

      <DocumentContentWrapper>
        <BlockLeft>{renderAttachment}</BlockLeft>
        <BlockRight>
          <div className="internal-doc-content-card">
            <h3 style={{ marginBottom: 16, fontSize: 18, fontWeight: 600 }}>
              Thông tin chung
            </h3>
            <Row gutter={[20, 16]}>
              <Col span={12}>
                <KeyValueItem label="Số hiệu" value={document_number} />
              </Col>
              <Col span={12}>
                <KeyValueItem label="Số đến" value={incoming_number} />
              </Col>
              <Col span={12}>
                <KeyValueItem
                  label="Ngày văn bản"
                  value={
                    date_issued ? (
                      <>
                        <span>
                          {moment(date_issued).format(DATE_FORMAT_SLASH)}
                        </span>
                      </>
                    ) : (
                      <EmptyText>Không có ngày văn bản.</EmptyText>
                    )
                  }
                />
              </Col>
              <Col span={12}>
                <KeyValueItem
                  label="Ngày đến"
                  value={
                    incoming_date ? (
                      <>
                        <span>
                          {moment(incoming_date).format(DATE_FORMAT_SLASH)}
                        </span>
                      </>
                    ) : (
                      <EmptyText>Không rõ ngày đến.</EmptyText>
                    )
                  }
                />
              </Col>
              <Col span={12}>
                <KeyValueItem
                  label="Người ký"
                  value={
                    signer ? signer : <EmptyText>Không có người ký.</EmptyText>
                  }
                />
              </Col>
              <Col span={12}>
                <KeyValueItem
                  label="Cơ quan ban hành"
                  value={WordBreak(
                    renderAuthorityIssuedList(
                      authority_issued_id,
                      agency_issued
                    )
                  )}
                />
              </Col>

              <Col span={24}>
                <KeyValueItem
                  label="Tài liệu đính kèm"
                  value={
                    attachments ? (
                      attachments.map(file => (
                        <FileItem
                          key={file.id}
                          file_id={file.id}
                          file_name={file.name}
                          file_type={utils.getExtensionFile(file.name)}
                        />
                      ))
                    ) : (
                      <EmptyText>Không có tài liệu đính kèm</EmptyText>
                    )
                  }
                />
              </Col>
              <Col span={24}>
                <KeyValueItem
                  label="Liên kết nhiệm vụ"
                  value={
                    <LinkedTask
                      linkedTaskList={linkedTask}
                      documentCode={documentId}
                      onSuccess={() =>
                        internalDocumentStore.getInternalDocumentIncomingById(
                          documentId
                        )
                      }
                    />
                  }
                />
              </Col>
              <Col span={24}>
                <KeyValueItem
                  label="Liên kết công việc"
                  value={
                    <LinkedWork
                      linkedWorkList={linkedWork}
                      documentCode={documentId}
                      onSuccess={() =>
                        internalDocumentStore.getInternalDocumentIncomingById(
                          documentId
                        )
                      }
                    />
                  }
                />
              </Col>
            </Row>
          </div>

          <div className="internal-doc-content-card">
            <Tabs defaultActiveKey="1">
              <Tabs.TabPane tab="Xử lý văn bản" key="1">
                {loading ? (
                  <div style={{ height: 150, position: 'relative' }}>
                    <SpinnerInlineComponent
                      sizeSpin={'small'}
                      tip="Đang tải dữ liệu..."
                      isLoading={loading}
                      backGround={'#ffffffc7'}
                    />
                  </div>
                ) : (
                  <div>
                    <Row gutter={[20, 16]}>
                      <Col span={12}>
                        <KeyValueItem
                          label="Lãnh đạo xử lý"
                          value={
                            handlerAssignList.length !== 0 ? (
                              <PopoverWatchTime
                                departWithUsers={departWithUsers}
                                userList={handlerAssignList}
                                title={'Lãnh đạo xử lý'}
                                isFullViewer={true}
                                compared_date={
                                  VIEWLOG_DATE.internal_document_until
                                }
                                typeId={documentId}
                                created_at={created_at}
                              />
                            ) : (
                              <EmptyText>Không có lãnh đạo xử lý.</EmptyText>
                            )
                          }
                        />
                      </Col>
                      <Col span={12}>
                        <KeyValueItem
                          label="Người xử lý"
                          value={
                            combinerAssignList.length !== 0 ? (
                              <PopoverWatchTime
                                departWithUsers={departWithUsers}
                                userList={combinerAssignList}
                                title={'Danh sách người xử lý'}
                                isFullViewer={true}
                                compared_date={
                                  VIEWLOG_DATE.internal_document_until
                                }
                                typeId={documentId}
                                created_at={created_at}
                              />
                            ) : (
                              <EmptyText>Không có người xử lý.</EmptyText>
                            )
                          }
                        />
                      </Col>
                      <Col span={24}>
                        <KeyValueItem
                          label="Phối hợp/ Theo dõi:"
                          value={
                            followerAssignList.length !== 0 ? (
                              <PopoverWatchTime
                                departWithUsers={departWithUsers}
                                userList={followerAssignList}
                                title={'Danh sách người phối hợp/ theo dõi'}
                                isFullViewer={true}
                                compared_date={
                                  VIEWLOG_DATE.internal_document_until
                                }
                                typeId={documentId}
                                created_at={created_at}
                              />
                            ) : (
                              <EmptyText>
                                Không có danh sách phối hợp/ theo dõi.
                              </EmptyText>
                            )
                          }
                        />
                      </Col>
                      <Col span={12}>
                        <KeyValueItem
                          label="Ngày bắt đầu"
                          value={
                            <span>
                              {start_date ? (
                                <span>
                                  {moment(start_date).format(DATE_FORMAT_SLASH)}
                                </span>
                              ) : (
                                <EmptyText>Không rõ.</EmptyText>
                              )}
                            </span>
                          }
                        />
                      </Col>
                      <Col span={12}>
                        <KeyValueItem
                          label="Ngày kết thúc"
                          value={
                            <span>
                              {end_date ? (
                                <>
                                  <span>
                                    {moment(end_date).format(DATE_FORMAT_SLASH)}
                                  </span>
                                </>
                              ) : (
                                <EmptyText>Không rõ.</EmptyText>
                              )}
                            </span>
                          }
                        />
                      </Col>
                    </Row>
                    <AccessControlAction
                      aclActionType={ACL_ACTION_TYPE.phanphat__INCOMING}>
                      <Button
                        type="primary"
                        onClick={() => setIsVisiblePopupPhanPhatDocument(true)}
                        className="custom-ant-button"
                        style={{
                          width: '100%',
                        }}>
                        Phân phát
                      </Button>
                    </AccessControlAction>
                  </div>
                )}
              </Tabs.TabPane>
              <Tabs.TabPane tab="Ý kiến" key="2">
                <InternalDocumentComment
                  documentId={documentId}
                  setIsLoadingComment={bool => setIsLoadingComment(bool)}
                />
                <SpinnerInlineComponent
                  sizeSpin={'small'}
                  isLoading={isLoadingComment}
                />
              </Tabs.TabPane>
            </Tabs>
          </div>
        </BlockRight>
      </DocumentContentWrapper>

      <PopupHandleDocument
        isVisiblePopupHandleDocument={isVisiblePopupHandleDocument}
        currentUser={currentUser}
        handleCancelHandleDocument={() =>
          setIsVisiblePopupHandleDocument(false)
        }
        handleCloseHandleDocument={() => setIsVisiblePopupHandleDocument(false)}
      />

      <PopupHandleHistory
        isVisiblePopupHistoryDocument={isVisiblePopupHistoryDocument}
        documentCode={documentId}
        handleCancelHistoryDocument={() =>
          setIsVisiblePopupHistoryDocument(false)
        }
        handleCloseHistoryDocument={() =>
          setIsVisiblePopupHistoryDocument(false)
        }
      />
      <PopupPhanPhatDocument
        typeDocument={DOCUMENT_TYPE.INCOMING}
        selectedInternalDocument={selectedInternalDocumentIncoming}
        commentLeaderList={commentLeaderList}
        isVisiblePopupPhanPhatDocument={isVisiblePopupPhanPhatDocument}
        handleClosePopupPhanPhatDocument={() =>
          setIsVisiblePopupPhanPhatDocument(false)
        }
      />
    </DashboardLayout>
  )
}

InternalDocumentIncomingIncomingDocDetailPage.propTypes = {}

export default inject(
  'accountStore',
  'commonStore',
  'internalDocumentStore',
  'loadingAnimationStore',
  'authenticationStore',
  'departmentStore',
  'staffStore',
  'fileStore',
  'notificationStore',
  'selectPeopleStore',
  'aclStore'
)(observer(InternalDocumentIncomingIncomingDocDetailPage))
